export class SupportTicketRequest {
  senderName: string;
  senderEmail: string;
  chargingStationID: string;
  chargingStationName: string;
  chargingStationManufacturer: string;
  chargingStationModel: string;
  chargingStationFirmwareVersion: string;
  customerName: string;
  chargingStationSerialNo: string;
  customerEnteredText: string;
  emailSubject: string;
  diagnostics: boolean
}
